import { SelectProps } from 'antd/lib/select';
import { useMemo } from 'react';
import { CssVariables } from 'styles/cssVariables';

export function useDefaultZIndex(style: SelectProps['styles']) {
	return useMemo(() => {
		if (typeof style == 'function') return style;

		const stylesInner = style ?? {};

		if (stylesInner.popup == null) {
			stylesInner.popup = {};
		}

		if (stylesInner.popup.root == null) {
			stylesInner.popup.root = {};
		}

		if (stylesInner.popup.root.zIndex != null) {
			return style;
		}

		stylesInner.popup.root.zIndex = CssVariables.zIndexControlPopover;

		return stylesInner;
	}, [style]);
}
